import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class QuickActionsService {
  private getBaseRoute(instanceId: string) {
    return `/api/configurations/${instanceId}/quick-actions`;
  }
  constructor(private http: HttpClient) {}

  forceFullIteration(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/force-full-iteration`, {});
  }

  clearSpPermissionsCache(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/clear-sharepoint-permissions-cache`, {});
  }

  clearSpGroupCache(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/clear-sharepoint-group-cache`, {});
  }

  clearSdkMessageProcessingSteps(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/clear-sdk-message-processing-steps`, {});
  }

  resetIssues(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/reset-issues`, {});
  }

  clearBrokenLinkCache(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/clear-broken-link-cache`, {});
  }
}
